import React, { useState, useEffect } from "react";

//COMPONENTES

import Button from "../../components/button";
import Loading from "../../components/loading";

import { LdapService } from "../../services/ldap";
import { validaFormatoSenha } from "../../utils/regex";
import { useSelector } from "react-redux";
import Input from "../../components/input";
import Checkbox from "../../components/checkbox";
import Message from "../../components/message";

function handleLoginError(error) {

    if (error.response) { // Resposta do servidor
        switch (error.response.status) {

            case 401:
                return "Usuário e/ou senha inválidos!";
            default:
                return "Erro desconhecido, tente novamente!";
        }
    } else if (error.request) { // Sem resposta da API

        return "Sem resposta do servidor, contate o administrador do sistema!";
    }

    return "Erro desconhecido, contate o administrador!";
}

const Login = () => {
    const [usuario, setUsuario] = useState('');
    const loggedInUser = useSelector(state => state.data);
    const [modal, setModal] = useState(false);
    const [result, setResult] = useState("");
    const [password, setPassword] = useState();
    const [mensagemFeedback, setMensagemFeedback] = useState('Informe seu usuário e senha do MEC.');
    const [tipoMensagemFeedback, setTipoMensagemFeedback] = useState('info');
    const [auth, setAuth] = useState();
    const [showTable, setShowTable] = useState(false);

    const [saveUser, isUsernameSaved] = useState(false);
    const [inputErrorMsg, setInputErrorMsg] = useState({
            usuario: { error: false, type: 'warning', message: '' },
            password: { error: false, type: 'warning', message: '' },
        });

    useEffect(() => {
        let loggedInUser = JSON.parse(localStorage.getItem("user"));

        if (loggedInUser != null) {
            window.location = '/lista-consumidores'
        } else {
            const savedUsername = localStorage.getItem('savedUsername');

            if (savedUsername) {
                isUsernameSaved(true);
                setUsuario(savedUsername);
            }
        }


    }, []);

    useEffect(() => {
        if (saveUser && usuario) {
            localStorage.setItem('savedUsername', usuario);
        } else {
            localStorage.removeItem('savedUsername');
        }

    }, [saveUser, usuario]);

    /**
     * 
     * @param {'usuario' | 'password'} campo Campo de input a se validado
     * @param {string[]} messageList Lista de mensagens do campo
     * @param {'warning' | 'danger' | 'status' | 'info'} type 
     * @param {boolean} haveError 
     */
    function setValidationInput(campo, messageList, type, haveError) {

        setInputErrorMsg(error => {
            error = { ...error };

            error[campo].type = type || 'warning';
            error[campo].error = haveError;

            error[campo].message = messageList.join('; ');
            return error;
        });
    }

    function validarInputs() {
        let valid = true;

        if (!usuario) {
            const errorList = ['Campo obrigatório!'];
            setValidationInput('usuario', errorList, 'warning', true);
            valid = false;
        } else {
            setValidationInput('usuario', [], '', false);
        }

        if (!password) {
            const errorList = ['Campo obrigatório!'];
            setValidationInput('password', errorList, 'warning', true);
            valid = false;
        } else {
            setValidationInput('password', [], '', false);
        }

        return valid;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setModal(true);
        setShowTable(false);

        if (!validarInputs()) {
            setModal(false);
            return;
        }

        LdapService.consultarLdap(usuario, password)
            .then((response) => {
                let resposta = response.data;
                let erro = false;
                if (!resposta.erro) {
                    localStorage.setItem('user', JSON.stringify(resposta.result));
                    window.location = "/lista-consumidores";
                } else {

                }
                setModal(false);
            })
            .catch((err) => {
                setMensagemFeedback(handleLoginError(err));
                setTipoMensagemFeedback('danger');
                setModal(false);
            });
    }


    let disabledSubmit = false;
    if (modal) {
        disabledSubmit = true;
    }


    return (

        <div id="signin-container" className="col-sm-6 col-md-6 col-xl-3" style={{ margin: "100px auto ", textAlign: "center" }}>
            <div className="br-card h-fixed" style={{ padding: "15px", margin: "100px auto ", textAlign: "center", boxShadow: " 6px 10px 7px -2px rgba(210,220,245,1)" }}>

                <h3 className="text-center" style={{ marginBottom: "5px", marginTop: "5px" }}>
                    LOGIN - LDAP
                </h3>

                <div className="login-box tab-pane active" tabIndex="0" role="tabpanel">
                    <form id="formulario" className="gl-show-field-erros" onSubmit={handleSubmit}>

                        <Message
                            onCloseButtonClick={() => setMensagemFeedback('')}
                            show={mensagemFeedback.length > 0}
                            type={tipoMensagemFeedback}
                            isContext={false}
                            messageTitle={mensagemFeedback}
                        />

                        <div className="d-flex flex-column align-items-start" style={{ marginTop: "20px" }}>

                            <div className="w-100">
                                <Input
                                    focus={true}
                                    value={usuario}
                                    id="usuario"
                                    placeholder="Digite o Usuário"
                                    density="input-highlight"
                                    label="Usuário"
                                    change={(e) => {
                                        setUsuario(e.target.value);
                                        setValidationInput('usuario', [], '', false);
                                    }}
                                    customClass={inputErrorMsg.usuario['error'] && inputErrorMsg.usuario['type']}
                                />
                            </div>
                            {inputErrorMsg.usuario['error'] &&
                                <Message
                                    isContext={true}
                                    type={inputErrorMsg.usuario['type']}
                                    message={inputErrorMsg.usuario['message']}
                                />
                            }

                        </div>

                        <div className="d-flex flex-column align-items-start" style={{ marginTop: "20px" }}>

                            <div className="w-100">
                                <Input
                                    value={password}
                                    type="password"
                                    placeholder="Digite a Senha"
                                    density="input-highlight"
                                    label="Senha"
                                    id="senha"
                                    change={(e) => {
                                        setValidationInput('password', [], '', false);
                                        setPassword(e.target.value);
                                    }}
                                    button={true}
                                    customClass={inputErrorMsg.password['error'] && inputErrorMsg.password['type']}
                                />
                            </div>
                            {inputErrorMsg.password['error'] &&
                                <Message
                                    isContext={true}
                                    type={inputErrorMsg.password['type']}
                                    message={inputErrorMsg.password['message']}
                                />
                            }
                        </div>

                        <div className="text-left pl-1 pt-3">
                            <Checkbox
                                data={[{
                                    id: 'save-username', label: 'Lembrar Usuário', checked: saveUser,
                                    onCheckChange: (isChecked) => {
                                        isUsernameSaved(isChecked);
                                    }
                                }]}
                            />
                        </div>

                        <div style={{ marginTop: "20px" }}>
                            <Button
                                backgroundDiv={false}
                                background="primary"
                                titulo="Entrar"
                                typeButton="submit"
                                className="botao"
                                onClick={(e) => handleSubmit(e)}
                                isDisabled={disabledSubmit}
                            />
                        </div>
                    </form>
                </div>

                <Loading showModal={modal} />

            </div>
            <br />
        </div>
    );
}

export default Login;

